<app-toast [toasts]="toasts"></app-toast>

<div class="container">
  <div class="row">
    <div class="col-12">
      <app-status-indicator-header
        [user]="user"
        [allMemberships]="allMemberships"
        [firstName]="user.profile_first_name"
        [lastName]="user.profile_last_name"
        [email]="user.profile_email"
        [loading]="membershipsLoading"
      ></app-status-indicator-header>
      <hr>
    </div>
    <div class="col-12" [ngClass]="{'col-lg-9': oneDaysSelected}">
      <app-license-step-progress-bar
        class="mb-3"
        currentStep="license-menu"
      ></app-license-step-progress-bar>

      <app-loader *ngIf="loading"></app-loader>

      <div class="mt-5" *ngIf="!loading">
        <!-- Event Information -->
        <app-event-information [event]="event" [eventOrganizer]="eventOrganizer"></app-event-information>

        <div id="upgrade-cta">
          <div class="cta-content row">
            <div class="col-md-9">
              <h4>Come Here Often? Upgrade to an Annual Membership and Save!</h4>
              <p class="small">Upgrade from a One-Day to an Annual Membership to save fees, and we’ll credit you $10 with code UPGRADEMEMBER</p>
            </div>
            <div class="col-md-3 mt-2 mt-md-0 text-md-right">
              <button class="btn btn-block btn-primary" (click)="toAnnualMembership()">UPGRADE</button>
            </div>
          </div>
        </div>

        <!-- License Purchase Menu -->
        <div class="pt-5">
          <app-form-title [customClasses]="['mb-4']">Purchase a One Day Membership</app-form-title>
          <h3>Select Event Days</h3>
          <app-form-subtitle [customClasses]="['text-left']">
            Choose the event days in which you'd like to participate. Selecting several event days or
            looking to purchase a USA Cycling Membership? <a href="/">Start here</a>. We’ll guide you
            to the plan and benefits that are right for your cycling needs, no matter your age, skill
            or experience level - or help you sign up the whole household.
          </app-form-subtitle>

          <app-one-day-license-menu-accordion *ngFor="let eventDate of eventDates; let i = index"
            [eventDate]='eventDate'
            [dayNumber]="i + 1"
            [skillSummary]="skillSummary"
            [licenseVariants]="licenseVariants"
            [purchasedOneDays]="purchasedOneDays"
            (formChange)='updateSelectedOneDays($event)'
          ></app-one-day-license-menu-accordion>
        </div>

      </div>
    </div>

    <app-one-day-license-cart *ngIf="oneDaysSelected"
      [selectedOneDays]="selectedOneDays"
      [user]="user"
      [event]="event"
      [experienceRequired]="experienceRequired"
    ></app-one-day-license-cart>

  </div>
</div>
